import { LinearGradient } from 'expo-linear-gradient';
import React, { useState } from 'react';
import { ScrollView, Text, TouchableOpacity, View } from 'react-native';
import toast from '../../utils/toast';
import InputDefault from '../Form/InputDefault';
import MaskedInputDefault from '../Form/MaskedInputDefault';
import GradientButton from '../GradientButton';

import { styles } from './styles';

const CreditCardForm = ({ onSubmit, submitText }) => {
  const [name, setName] = useState("");
  const [numberCard, setNumberCard] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [ccv, setCcv] = useState("");

  const [email, setEmail] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [phone, setPhone] = useState("");

  async function saveCard() {
    if (!name) {
      toast("Preencha o nome.", "#DA1414");
      return false;
    }

    if (!numberCard) {
      toast("Preencha o número do cartão.", "#DA1414");
      return false;
    }

    if (!expirationDate) {
      toast("Preencha a validade do cartão.", "#DA1414");
      return false;
    }

    if (!ccv) {
      toast("Preencha o ccv do cartão.", "#DA1414");
      return false;
    }

    if (!email) {
      toast("Preencha email do portador.", "#DA1414");
      return false;
    }

    if (!cpfCnpj) {
      toast("Preencha o cpf/cnpj do portador.", "#DA1414");
      return false;
    }
    if (!postalCode) {
      toast("Preencha o CEP do portador.", "#DA1414");
      return false;
    }
    if (!addressNumber) {
      toast("Preencha o Número do endereço do portador.", "#DA1414");
      return false;
    }
    if (!phone) {
      toast("Preencha o telefone do portador.", "#DA1414");
      return false;
    }

    const [month, year] = expirationDate.split("/");

    const data = {
      creditCard: {
        holderName: name,
        number: numberCard,
        expiryMonth: month,
        expiryYear: year,
        ccv,
      },
      creditCardHolderInfo: {
        name,
        email,
        cpfCnpj,
        postalCode,
        addressNumber,
        phone,
      },
    };

    onSubmit(data);
  }

  return (
    <ScrollView style={styles.container}>
      <InputDefault
        value={name}
        onValueChange={(value) => setName(value)}
        placeholder={"Nome completo"}
      />

      <MaskedInputDefault
        mask="9999 9999 9999 9999"
        keyboardType="numeric"
        value={numberCard}
        onValueChange={(value) => setNumberCard(value)}
        placeholder={"Número do cartão"}
      />

      <MaskedInputDefault
        mask="99/9999"
        keyboardType="numeric"
        value={expirationDate}
        onValueChange={(value) => setExpirationDate(value)}
        placeholder={"Validade"}
      />

      <MaskedInputDefault
        mask="9999"
        keyboardType="numeric"
        value={ccv}
        onValueChange={(value) => setCcv(value)}
        placeholder={"CCV"}
      />

      <Text style={styles.holderTitle}>Dados do portador</Text>

      <InputDefault
        value={email}
        onValueChange={(value) => setEmail(value)}
        placeholder={"E-mail"}
      />

      <MaskedInputDefault
        mask="999.999.999-99"
        keyboardType="numeric"
        value={cpfCnpj}
        onValueChange={(value) => setCpfCnpj(value)}
        placeholder={"Cpf/Cnpj"}
      />

      <MaskedInputDefault
        mask="99.999-999"
        keyboardType="numeric"
        value={postalCode}
        onValueChange={(value) => setPostalCode(value)}
        placeholder={"Cep"}
      />

      <InputDefault
        value={addressNumber}
        keyboardType="numeric"
        onValueChange={(value) => setAddressNumber(value)}
        placeholder={"Número"}
      />

      <MaskedInputDefault
        mask="(99) 99999-9999"
        keyboardType="numeric"
        value={phone}
        onValueChange={(value) => setPhone(value)}
        placeholder={"Telefone"}
      />

      <View style={styles.contentBtn}>
        <GradientButton onPress={saveCard}>{submitText}</GradientButton>
      </View>
    </ScrollView>
  );
}

export default CreditCardForm;